import { pushDataLayerEvent } from 'src/helpers/gtm';
import type { SeoAppDataLayerEvents } from 'src/routes/SeoApp/domain/state/analytics/types';

/**
 * Отправляет событие ccx-pageview
 */
export const pushCcxPageview = pushDataLayerEvent<
  SeoAppDataLayerEvents,
  { search_params: Record<string, any> | null }
>('ccx-pageview');

export const pushExploreLoadingStart =
  pushDataLayerEvent<SeoAppDataLayerEvents>('explore_loading_start');

export const pushExploreLoadingSuccess =
  pushDataLayerEvent<SeoAppDataLayerEvents>('explore_loading_success');

export const pushExploreHotelClicked = pushDataLayerEvent<
  SeoAppDataLayerEvents,
  { hotel_id: string }
>('explore_hotel_clicked');

export const pushExploreSortChanged = pushDataLayerEvent<
  SeoAppDataLayerEvents,
  { type: string }
>('explore_sort_changed');

export const pushExploreLinkClicked = pushDataLayerEvent<
  SeoAppDataLayerEvents,
  {
    custom_params: {
      type:
        | 'month' // Клик по месяцу
        | 'recommendation' // Клик по рекомендациям
        | 'country' // Клик по странам
        | 'other_regions' // Клик по соседним регионам
        | 'alternative' // Клик по альтернативной выдаче TBD
        | 'country_list_expand' // Клик по кнопке "Остальные страны" в блоке списка стран
        | 'country_list'; // Клик по стране в блоке списка стран
      country_iso2?: string; // iso2 страны для события с type = 'country_list'
      country_list_placement?: 'top' | 'bottom'; // положение в зависимости от isMetaregion для события с type = 'country_list'
      _clear?: boolean;
    };
  }
>('explore_link_clicked');

export const pushExploreLoadingMoreStart =
  pushDataLayerEvent<SeoAppDataLayerEvents>('explore_loading_more_start');
export const pushExploreExploreLoadingMoreFinish =
  pushDataLayerEvent<SeoAppDataLayerEvents>('explore_loading_more_finish');
export const pushExploreLoadingMoreError = pushDataLayerEvent<
  SeoAppDataLayerEvents,
  { error: string }
>('explore_loading_more_error');
